import React, { useEffect, useState } from 'react';

interface CompetencyProgress { earned:number; possible:number; pct:number; completedIds:number[] }
interface ProgressReport { generatedAt:string; competencies: Record<string, CompetencyProgress> }

const ProgressPage: React.FC = () => {
  const [report, setReport] = useState<ProgressReport | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Try fetching existing file generated by score script
    fetch('/reports/progress.json')
      .then(r => r.ok ? r.json() : Promise.reject(new Error('Missing progress.json (run npm run score)'))) 
      .then(setReport)
      .catch(e => setError(e.message));
  }, []);

  return (
    <div style={{padding:'1rem'}}>
      <h1>Progress Dashboard</h1>
      {error && <p style={{color:'crimson'}}>{error}</p>}
      {!error && !report && <p>Loading progress...</p>}
      {report && (
        <>
          <p><em>Generated: {new Date(report.generatedAt).toLocaleString()}</em></p>
          <table style={{borderCollapse:'collapse'}}>
            <thead>
              <tr>
                <th style={th}>Competency</th>
                <th style={th}>Earned</th>
                <th style={th}>Possible</th>
                <th style={th}>Pct</th>
                <th style={th}>Completed IDs</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(report.competencies).map(([k,v]) => (
                <tr key={k}>
                  <td style={td}>{k}</td>
                  <td style={td}>{v.earned}</td>
                  <td style={td}>{v.possible}</td>
                  <td style={td}>{v.pct}%</td>
                  <td style={td}>
                    {v.completedIds.length ? v.completedIds.join(', ') : <span style={{opacity:0.5}}>—</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      <p style={{marginTop:'1rem', fontSize:'0.8rem'}}>Tip: Run <code>npm run score</code> locally or in CI to refresh this report.</p>
    </div>
  );
};

const th: React.CSSProperties = { border:'1px solid #ccc', padding:'4px 8px', background:'#f6f6f6'};
const td: React.CSSProperties = { border:'1px solid #ddd', padding:'4px 8px'};

export default ProgressPage;
